import customAxios from "./axiosConfig";

const CorrectionService = {
  create (data) {
    const api_url = window.Urls['correction-list']()
    return customAxios.post(api_url, data)
  }
}

export default CorrectionService;